export default [
  {
    key: 'remarkMedia',
    label: 'field.media',
    initKey: 'screenshot',
    rules: 'size:10000',
    type: 'multi-image',
    fullWidth: true,
    pw: 1080,
    ph: 1920,
    cols: 12,
  },
  {
    key: 'remark',
    label: 'label.remark',
    // hint: 'label.remarkHint',
    type: 'textarea',
    rules: 'required|min:2|max:1000',
    rows: '5',
    cols: 12,
  },
]
